<template>
  <div class="dashboard-page">
    <v-tabs v-model="tab" vertical>
      <v-tab
        v-for="(tab, index) in tabs"
        :key="index"
        @click="currentTab = tab.value"
        >{{ tab.text }}</v-tab
      >

      <v-tab-item :value="tab" :reverse-transition="false" :transition="false">
        <keep-alive>
          <component :is="currentTabComponent"></component>
        </keep-alive>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
  export default {
    name: "DashboardPage",
    components: {
      AnnualGraphTab: () =>
        import("@/views/dashboard/components/AnnualGraphTab.vue"),
      DetailedTableTab: () =>
        import("@/views/dashboard/components/DetailedTableTab.vue")
    },
    data() {
      return {
        tab: null,
        currentTab: "AnnualGraph",
        tabs: [
          { text: "Graphique Annuel", value: "AnnualGraph" },
          { text: "Tableau détailé", value: "DetailedTable" }
        ]
      };
    },
    computed: {
      currentTabComponent() {
        return this.currentTab + "Tab";
      }
    }
  };
</script>

<style lang="scss">
  .settings-page {
    height: 100%;
    .v-tabs {
      height: 100%;
      .v-tab {
        justify-content: flex-start;
      }
      .v-window {
        padding: 15px;
      }
    }
    .v-btn {
      background-color: #006064 !important;
      color: white;
    }
    .filters-container {
      background-color: #f0f0f0;
      padding: 30px;
    }
    .v-data-table {
      table {
        tr {
          background-color: white !important;
          &.v-row-group__header {
            background-color: rgba(132, 31, 99, 0.05) !important;
            .v-btn {
              display: none;
            }
          }
          &:not(.v-row-group__header) {
            td,
            th {
              &:not(:last-child) {
                border-right: 1px solid #707070;
              }
            }
          }
        }
      }
    }

    .selected {
      color: red !important;
    }
  }
</style>
